export default __webpack_public_path__ + "static/media/055-milk.cfe9669d.svg";